@if (open()) {
    <form class="form" (submit)="submit($event)">
        <app-form-text class="code" inputId="scan-emulator-code" placeholder="Scan code" [(value)]="code" />
        <app-button type="submit" size="sm">Scan</app-button>
        <button class="close" type="button" aria-label="Close scan emulator" (click)="open.set(false)">
            <app-icon name="x-mark" />
        </button>
    </form>
} @else {
    <button class="pill" type="button" aria-label="Open scan emulator" (click)="open.set(true)">
        <app-icon name="scan" />
    </button>
}
